/**
 * Aktivitäten-Feed (P2-C inc.6): Beschriftungen und Kategorie-Farben je
 * Ereignis-Art. Preisfrei und ortungsfrei — der Leistungsort ist reiner Text.
 * Gemeinsam genutzt von der Aktivitäten-Seite und dem Dashboard-Widget.
 */
export const ACTIVITY_KIND_LABELS: Record<string, string> = {
  WORK_START: 'Arbeit gestartet',
  STOP: 'Auftrag beendet / Wechsel',
  PAUSE_START: 'Pause',
  PAUSE_END: 'Weiter',
  TECH_DONE: 'Fertig gemeldet',
  ADHOC_CREATED: 'Ad-hoc-Auftrag angelegt',
  WORK_REPORT_CREATED: 'Arbeitsnachweis erzeugt',
  ABSENCE_REQUESTED: 'Urlaub beantragt',
  ABSENCE_REPORTED: 'Krank gemeldet',
  ABSENCE_APPROVED: 'Abwesenheit genehmigt',
  ABSENCE_REJECTED: 'Abwesenheit abgelehnt',
  ABSENCE_CANCELLED: 'Antrag zurückgezogen',
  // P2-G §3 On-hold: freundliche Beschriftungen, falls der Feed die Hold-
  // Ereignisse künftig mitführt (Monteur-OrderEvents bzw. Audit-Aktionen). Der
  // Feed rendert unbekannte Arten generisch (`?? e.kind`); diese Einträge sorgen
  // dafür, dass eine Hold-Zeile lesbar erscheint, sobald sie durchgereicht wird.
  PROBLEM_REPORTED: 'On-hold gemeldet',
  PROBLEM_RESOLVED: 'On-hold aufgehoben',
  ORDER_HOLD_SET: 'On-hold gesetzt',
  ORDER_HOLD_RESOLVED: 'On-hold aufgehoben',
  ORDER_HOLD_CUSTOMER_MAILED: 'Auftraggeber informiert',
};

export const ACTIVITY_CATEGORY_LABELS: Record<string, string> = {
  ORDER: 'Auftrag',
  ADHOC: 'Ad-hoc',
  WORK_REPORT: 'Arbeitsnachweis',
  ABSENCE: 'Abwesenheit',
};

/** Auswahl der Typ-Filter (Kategorien) für die Filterleiste. */
export const ACTIVITY_CATEGORY_OPTIONS = [
  { value: 'ORDER', label: 'Auftrag' },
  { value: 'ADHOC', label: 'Ad-hoc' },
  { value: 'WORK_REPORT', label: 'Arbeitsnachweis' },
  { value: 'ABSENCE', label: 'Abwesenheit' },
];

/** Kategorie-Farbe (CSS-Variable) für den Marker-Punkt. */
export function activityCategoryColor(category: string): string {
  switch (category) {
    case 'ORDER':
      return 'var(--wb-primary-600)';
    case 'ADHOC':
      return 'var(--wb-status-emergency)';
    case 'WORK_REPORT':
      return 'var(--wb-status-paid)';
    case 'ABSENCE':
      return 'var(--wb-status-due)';
    default:
      return 'var(--wb-text-faint)';
  }
}

// Vollanalyse M12: kanonische Zeitstempel-Formatter liegen in lib/format.ts
// (Europe/Berlin als verbindliche Anzeige-Zeitzone); hier nur der Re-Export.
export { formatDateTimeDE, formatTimeDE } from './format';
